<template>
  <div class="landing-info">
    <div v-for="(item,index) in items" :key="index" class="landing-info__item"
         :class="[
           {'landing-info__item_odd': !isOdd(index)},
           item.class ? `item-${item.class}` : '']"
    >
      <VContainer>
        <VRow :class="{'flex-row-reverse': !isOdd(index)}" no-gutters>
          <VCol :offset-lg="isOdd(index) ? undefined : 1"
                class="d-flex justify-center"
          >
            <div class="landing-info__text-wrap">
              <div class="landing-info__name text-center text-md-left" v-html="item.title" />
              <div class="landing-info__text text-left" v-html="item.text" />
            </div>
          </VCol>
          <VCol :class="{'justify-center': !isOdd(index)}"
                class="d-sm-flex col-12 justify-center" md="6"
          >
            <div class="landing-info__image-wrap">
              <img
                :src="require(`../../assets/img/landing/info/${item.image}`)"
                :srcset="item.image2 ?
                  require(`../../assets/img/landing/info/${item.image2}`) + ' 2x': undefined"
                alt=""
                class="landing-info__image"
              >
            </div>
          </VCol>
        </VRow>
      </VContainer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingSocialInfo',
  data() {
    return {
      items: this.$t('items'),
    };
  },
  methods: {
    isOdd(index) {
      return index % 2 === 0;
    },
  },
};
</script>

<style scoped lang="scss">
  .landing-info {
    padding-top: 2.125rem;
    background-color: #FFFFFF;
    overflow: hidden;
    &__item {
      position: relative;
      background-color: #FFFFFF;
      &_odd {
        background-color: #E9F3FE;
      }
      &.item-intro {
        .landing-info__image-wrap {
          bottom: -1.125rem;
        }
        .landing-info__text-wrap {
          padding: 4.25rem 0 4.375rem;
        }
      }
      &.item-conveniently {
        &:after {
          content: '';
          position: absolute;
          left: 1.25rem;
          bottom: 1.25rem;
          background: url("../../assets/img/landing/info/info4-bg.svg") no-repeat center;
          background-size: contain;
        }
        .landing-info__image-wrap {
          padding-top: 2.75rem;
          &:after {
            width: 17.25rem;
            height: 14rem;
            content: '';
            background: url("../../assets/img/landing/info/info4-lens.svg") no-repeat center;
            background-size: contain;
            position: absolute;
            right: -8.125rem;
            bottom: 3.875rem;
            z-index: 3;
          }
        }
        .landing-info__text-wrap {
          padding-top: 12.5rem;
        }
      }
      &.item-social {
        padding-bottom: 1.625rem;
        &:before {
          width: 14.5rem;
          height: 12.5rem;
          content: '';
          background: url("../../assets/img/landing/info/social-info-bg-1.svg") no-repeat center top;
          background-size: contain;
          position: absolute;
          bottom: -1rem;
          left: 3%;
          z-index: 1;
        }
        .landing-info__text-wrap {
          padding-top: 4.5rem;
          padding-bottom: 2.5rem;
        }
        .landing-info__name {
          max-width: 22rem;
        }
      }
      &.item-statistic {
        padding: 2.5rem 0 3.5rem;
        &:before {
          width: 16.25rem;
          height: 14rem;
          content: '';
          background: url("../../assets/img/landing/info/social-info-bg-2.svg") no-repeat center top;
          background-size: contain;
          position: absolute;
          bottom: 3.375rem;
          left: 2%;
          z-index: 1;
        }
        &:after {
          width: 16.25rem;
          height: 14rem;
          content: '';
          background: url("../../assets/img/landing/info/social-info-bg-2.svg") no-repeat center top;
          background-size: contain;
          position: absolute;
          bottom: 3.375rem;
          right: -2.5rem;
          z-index: 1;
        }
        .landing-info__text-wrap {
          align-self: center;
          padding-top: 0;
        }
      }
    }
    &__image-wrap {
      display: inline-block;
      position: relative;
    }
    &__image {
      max-width: 100%;
      height: auto;
      position: relative;
      z-index: 2;
    }
    &__text-wrap {
      padding-top: 2.125rem;
      max-width: 428px;
      color: #666666;
      font-size: 1.125rem;
      line-height: 1.55;
      position: relative;
      z-index: 2;
    }
    &__name {
      color: #000;
      font-size: 2rem;
      font-weight: 500;
      line-height: 1.19;
      margin-bottom: 1.25rem;
    }
  }

  @media only screen and (max-width: 1500px) {
    .landing-info {
      &__item {
        &.item-conveniently {
          .landing-info__text-wrap {
            padding-top: 9.25rem;
          }
          .landing-info__image-wrap {
            padding: 2.5rem 6rem 0 0;
            &:after {
              width: 15rem;
              right: 0;
              bottom: 2rem;
            }
          }
        }
        &.item-statistic {
          &:before {
            width: 14rem;
            height: 12rem;
            bottom: 3rem;
          }
          &:after {
            width: 14rem;
            height: 12rem;
            bottom: 3rem;
            right: -2rem;
          }
        }
      }
    }
  }

  @media #{map-get($display-breakpoints, 'md-and-down')} {
    .landing-info {
      &__item {
        &.item-intro {
          .landing-info__text-wrap {
            padding: 2.5rem 0;
          }
        }
        &.item-conveniently {
          .landing-info__text-wrap {
            padding-top: 6rem;
          }
          .landing-info__image-wrap {
            padding: 2rem 3rem 0 0;
            &:after {
              width: 10rem;
              right: -1rem;
              bottom: -0.5rem;
            }
          }
        }
        &.item-statistic {
          &:before {
            width: 12rem;
            height: 10rem;
            left: -3rem;
            bottom: -2rem;
          }
          &:after {
            width: 12rem;
            height: 10rem;
            bottom: 0.5rem;
            right: -3rem;
          }
        }
      }
      &__image-wrap {
        text-align: center;
        max-width: 38rem;
      }
      &__image {
        display: inline-block;

      }
      &__text-wrap {
        padding-left: 1.25rem;
        font-size: 1rem;
      }
      &__name {
        font-size: 1.5625rem;
        margin-bottom: 1.25rem;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .landing-info {
      &__item {
        &.item-intro {
          .landing-info__text-wrap {
            padding: 2rem 0 1rem;
          }
        }
        &.item-conveniently {
          padding-bottom: 2rem;
          .landing-info__text-wrap {
            padding-top: 2rem;
          }
          .landing-info__image-wrap {
            padding: 2rem 2rem 0 0;
            &:after {
              width: 12rem;
              right: 0;
              bottom: 0;
            }
          }
        }
        &.item-social {
          padding-bottom: 1.25rem;
          &:before {
            content: none;
          }
          .landing-info__text-wrap {
            padding-top: 0;
            padding-bottom: 1.5rem;
          }
        }
        &.item-statistic {
          padding: 1.5rem 0;
          &:before {
            content: none;
          }
          &:after {
            content: none;
          }
          .landing-info__text-wrap {
            padding-bottom: 2rem;
          }
        }
      }
      &__image {
        padding: 0;
        max-width: 80%;
      }
      &__text-wrap {
        padding: 0;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .landing-info {
      &__item {
        &.item-intro {
          .landing-info__text-wrap {
            padding: 1rem 0 0.5rem;
          }
        }
        &.item-conveniently {
          padding-bottom: 2rem;
          .landing-info__text-wrap {
            padding-top: 1.5rem;
          }
          .landing-info__image-wrap {
            &:after {
              width: 35%;
              right: -1rem;
              bottom: -1.875rem;
            }
          }
        }
        &.item-social {
          padding-bottom: 1.25rem;
          .landing-info__image-wrap {
            display: block;
            width: 13.5rem;
            margin: 0 auto;
          }
          .landing-info__text-wrap {
            padding-top: 0;
            padding-bottom: 1.5rem;
          }
        }
      }
      &__image {
        max-width: 100%;
      }
    }
  }
  @media only screen and (max-width: 374px) {
    .landing-info {
      &__item {
        &.item-conveniently {
          .landing-info__image-wrap {
            padding-right: 1.5rem;
          }
        }
      }
      &__name {
        font-size: 1.4375rem;
        margin-bottom: 0.875rem;
      }
      &__text-wrap {
        font-size: 0.9375rem;
      }
    }
  }

</style>

<i18n locale="en" lang="yaml">
items:
  - title: Ваши вакансии в телефоне
    text: "Меняйте статусы кандидатов, перетягивая карточки на канбан-доске. Фильтры, сортировки, поиск — работа с кандидатами еще никогда не была такой удобной!"
    image: social-info1.png
    class: social
  - title: Huntica will interview<br> your candidates for you
    text: "Tired of asking candidates the same questions, making appointments,
      adjusting to late arrivals? Our service was created to save you from
      the same old routine! Post a job, invite candidates, and let Huntica
      interview them for you. We will remind applicants about the interview,
      and our artificial intelligence will interview them without needing your participation.
      Find out how easy it is take a <a href='/en/demo'>test interview</a>"
    image: social-info2.png
    class: intro
  - title: Conveniently organize your workflow<br>with applicants
    text: "Change candidate statuses by dragging and dropping cards on the bulletin board.
      Filters, sorting, search - working with candidates has never been more convenient!"
    image: info4.svg
    class: conveniently
  - title: Изучайте статистику
    text: "Наш сервис создан, чтобы снять с вас рутину! Создайте вакансию, пригласите кандидатов и позвольте Хантике провести собеседования за вас. Мы сами напомним соискателям про собеседование, а наш искусственный интеллект проведет его без вашего участия."
    image: social-info3.svg
    class: statistic
</i18n>

<i18n locale="ru" lang="yaml">
items:
  - title: Ваши вакансии в телефоне
    text: "Меняйте статусы кандидатов, перетягивая карточки на канбан-доске. Фильтры, сортировки, поиск — работа с кандидатами еще никогда не была такой удобной!"
    image: social-info1.png
    class: social
  - title: Huntica проведет<br>собеседования за вас
    text: "Устали задавать кандидатам одни и те же вопросы, согласовывать встречи,
      подстраиваться под их опоздания? Наш сервис создан, чтобы снять с вас рутину!
      Создайте вакансию, пригласите кандидатов и позвольте Хантике провести
      собеседования за вас. Мы сами напомним соискателям про собеседование,
      а наш искусственный интеллект проведет его без вашего участия.
      Узнайте, как просто это работает – пройдите
      <a href='/ru/demo'>тестовое собеседование</a>!"
    image: social-info2.png
    class: intro
  - title: Работайте с соискателями удобно
    text: "Меняйте статусы кандидатов, перетягивая карточки на канбан-доске.
    Фильтры, сортировки, поиск – работа с кандидатами еще никогда не была такой удобной!"
    image: info4.svg
    class: conveniently
  - title: Изучайте статистику
    text: "Наш сервис создан, чтобы снять с вас рутину! Создайте вакансию, пригласите кандидатов и позвольте Хантике провести собеседования за вас. Мы сами напомним соискателям про собеседование, а наш искусственный интеллект проведет его без вашего участия."
    image: social-info3.svg
    class: statistic
</i18n>
